import { IHttpClient } from '@/core/services/http'

export function createGetTermsAndConditionsUseCase({
  httpClient,
}: {
  httpClient: IHttpClient
}) {
  return async function () {
    try {
      const response = await httpClient
        .version('v1')
        .get<{ data: string }>('/website/customer/TermsAndConditions')

      return response.data.data
    } catch (_) {
      return ''
    }
  }
}
